// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"69":"533e39b748b267de0547","655":"5d078b10e40a2180dc39"}[chunkId] + ".js";
};